import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _, { set } from 'lodash';
import * as api from '../../../api';
import Button from '../../../components/bootstrap/Button';
import Card, {
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import { setAlert, setLoading, setVehiclePreviewPage } from '../../../globalState/action-creators';
import './media.css';
import Select from '../../../components/bootstrap/forms/Select';
import { HoldVehicleType } from '../../../constants';
import { AutoComplete } from 'antd';
import 'antd/dist/antd.css';
import DatePicker from 'react-date-picker';
import moment from 'moment';

const AddHoldVehicle = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const today = new Date();
	const token = sessionStorage.getItem('token');

	const [nameError, setNameError] = useState(false);
	const [licensePlateError, setLicensePlateError] = useState(false);
	const [makeError, setMakeError] = useState(false);
	const [modelError, setModelError] = useState(false);
	const [vehicleTypeError, setVehicleTypeError] = useState(false);
	const [dropdownSelected, setDropdownSelected] = useState(false);
	const [selectNameError, setSelectNameError] = useState(false);
	const [moveInDateError, setMoveInDateError] = useState(false);
	const [startTimeError, setStartTimeError] = useState(false);

	const [unitNumber, setUnitNumber] = useState('');
	const [residentType, setResidentType] = useState('');

	const [searchData, setSearchData] = useState({
		total: 0,
		name: [],
	});

	useEffect(() => {
		if (!token) {
			navigate('/auth-pages/login', { replace: true });
			return;
		}
		fetchResidentUnitNumber();
		// eslint-disable-next-line
	}, []);

	// GET unit DATA
	const fetchResidentUnitNumber = async () => {
		try {
			const { data } = await api.getResidentUnitNumber();
			if (data?.success) {
				setUnitNumber(data?.data?.unitId);
				setResidentType(data?.data?.residentType);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const [formData, setFormData] = useState({
		name: '',
		licensePlate: '',
		make: '',
		model: '',
		vehicleType: '',
		MoveInDate: '',
		MoveOutDate: '',
		startTime: '',
		endTime: '',
		
	});

	const onChange = (e) => {
		const { name, value } = e.target;
		if (name === 'name') {
			setNameError(false);
		}
		if (name === 'licensePlate') {
			setLicensePlateError(false);
		}
		if (name === 'make') {
			setMakeError(false);
		}
		if (name === 'model') {
			setModelError(false);
		}
		if (name === 'vehicleType') {
			setVehicleTypeError(false);
		}
		if (name === 'MoveInDate') {
			setMoveInDateError(false);
		}
		if (name === 'startTime') {
			setStartTimeError(false);
		}

		if (
			name === 'vehicleType' &&
			(value === 'Homeowner Resident' || value === 'Tenant Resident')
		) {
			setFormData({
				...formData,
				[name]: value,
				MoveInDate: null,
				MoveOutDate: null,
				startTime: null,
				endTime: null,
			});

			setMoveInDateError(false);
		} else {
			setFormData({ ...formData, [name]: value });
		}
	};

	const createVehicle = async () => {
		dispatch(setLoading(true));
		try {
			let error;
		
			if (_.get(formData, 'name', '')?.length <= 0) {
				error = true;
				setNameError(true);
			}
			if (
				_.get(formData, 'licensePlate', '')?.length <= 0
				// !reDigit.test(_.get(formData, 'licensePlate', ''))
			) {
				error = true;
				setLicensePlateError(true);
			}
			if (_.get(formData, 'make', '')?.length <= 0) {
				error = true;
				setMakeError(true);
			}
			if (_.get(formData, 'model', '')?.length <= 0) {
				error = true;
				setModelError(true);
			}
			if (_.get(formData, 'vehicleType', '')?.length <= 0) {
				error = true;
				setVehicleTypeError(true);
			}
			if (formData?.vehicleType === 'Unit Guest') {
				if (_.get(formData, 'MoveInDate', '')?.length <= 0) {
					error = true;
					setMoveInDateError(true);
				}

				if (_.get(formData, 'MoveInDate', '')?.length > 0) {
					const moveInDate = new Date(formData.MoveInDate);
					const yesterday = new Date();
					yesterday.setDate(yesterday.getDate() - 1);
					if (moveInDate < yesterday) {
						error = true;
						setMoveInDateError(true);
					}
				}

				if (_.get(formData, 'startTime', '')?.length <= 0) {
					error = true;
					setStartTimeError(true);
				}
			}

			if (!error) {
				const { data } = await api.createVehicle(formData);
				if (data.success) {
					dispatch(setVehiclePreviewPage({ vehiclePage: 1 }));
					navigate('/vehicles');
					dispatch(setAlert(data.message, 'Success'));
				} else {
					dispatch(setAlert(data.message, 'Error'));
				}
			}
		} catch (error) {
			dispatch(setAlert(error.message, 'Error'));
		}
		dispatch(setLoading(false));
	};

	const handleSearch = async (name) => {
		try {
			const { data } = await api.searchNames(name);
			if (data.success) {
				setSearchData({
					total: data.total || 0,
					name: data?.data ? data?.data : [],
				});
			}
		} catch (error) {
			setAlert(error.message, 'error');
		}
	};

	useEffect(() => {
		if (unitNumber && formData?.MoveInDate && formData?.startTime) {
			const { guestAccessDuration, guestAccessDurationType } = unitNumber;

			let calculatedEndDate;
			if (guestAccessDuration && guestAccessDurationType) {
				// Combine MoveInDate and startTime
				const startDateTime = moment(
					`${formData.MoveInDate} ${formData.startTime}`,
					'MM/DD/yyyy HH:mm',
				);
				calculatedEndDate = startDateTime.add(
					Number(guestAccessDuration),
					guestAccessDurationType.toLowerCase(),
				);
			}

			setFormData((prevFormData) => ({
				...prevFormData,
				MoveOutDate: calculatedEndDate ? calculatedEndDate.format('MM/DD/yyyy') : '',
				endTime: calculatedEndDate ? calculatedEndDate.format('HH:mm') : '',
			}));
		}
	}, [unitNumber, formData?.MoveInDate, formData?.startTime]);

	const vehicleTypes =
		residentType === 'Homeowner Admin'
			? HoldVehicleType.filter((type) => type.value === 'Homeowner Resident' || type.value === 'Unit Guest')
			: residentType === 'Tenant Admin'
			? HoldVehicleType.filter((type) => type.value === 'Tenant Resident' || type.value === 'Unit Guest')
			: HoldVehicleType;

	return (
		<PageWrapper title='Add Vehicle'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-xxl-6'>
						<Card stretch>
							<CardHeader>
								<CardLabel icon='Plus' iconColor='dark'>
									<CardTitle tag='h4' className='h5'>
										Create Vehicle
									</CardTitle>
								</CardLabel>
							</CardHeader>
							<CardBody>
								<div className='row'>
									<div className='create_vehicle_inner'>
										<div className='create-vehicle-wrapper add_vehicle'>
											{/* <div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														Name{' '}
														<span className='text-danger fw-bold'>
															*
														</span>
													</p>
												</div>
												<div className='data'>
													<AutoComplete
														onSearch={handleAutoCompleteInput}
														className='w-100 custom_class'
														value={formData?.name}
														onSelect={handleAutoCompleteSelect}
														onChange={handleAutoCompleteChange}
														// onChange={() => {
														// 	setDropdownSelected(false);
														// }}
														onBlur={() => {
															!dropdownSelected &&
																setSelectNameError(true);
														}}
													>
														{searchData &&
															searchData?.name?.map((item) => (
																<AutoComplete.Option
																	key={item?._id}
																	value={item?.name}
																>
																	{item?.name}
																</AutoComplete.Option>
															))}
													</AutoComplete>
												</div>
												<span
													id='yearOfMakeSpan'
													className='text-danger danger-msg'
												>
													{nameError
														? 'Please enter a name'
														: !nameError &&
														  !dropdownSelected &&
														  selectNameError &&
														  formData?.name?.length > 0 &&
														  'Please select a name from options!'}
												</span>
											</div> */}

											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														Name{' '}
														<span className='text-danger fw-bold'>
															*
														</span>
													</p>
												</div>
												<div className='data'>
													<input
														type='text'
														className='form-control addVehicleSelect'
														autoComplete='off'
														name='name'
														onChange={(e) => {
															onChange(e);
														}}
														style={styles.inputStyles}
													/>
												</div>
												<span
													id='licensePlatesStateSpan'
													className='text-danger danger-msg'
												>
													{nameError && 'Please enter a name!'}
												</span>
											</div>

											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														License Plate{' '}
														<span className='text-danger'>*</span>
													</p>
												</div>
												<div className='data'>
													<input
														type='text'
														id='licensePlates'
														className='form-control addVehicleSelect no-arrows'
														autoComplete='off'
														name='licensePlate'
														onChange={(e) => {
															onChange(e);
														}}
														onKeyDown={(e) => {
															const key = e.key;
															const isSpecialCharacter =
																/[!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]+/;

															if (
																key === ' ' ||
																(isSpecialCharacter.test(key) &&
																	key !== '-')
															) {
																e.preventDefault();
															}
														}}
														style={styles.inputStyles}
													/>
												</div>
												<span
													id='licensePlatesSpan'
													className='text-danger danger-msg'
												>
													{licensePlateError &&
														'License Plate Number required!'}
												</span>
											</div>

											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														Make{' '}
														<span className='text-danger fw-bold'>
															*
														</span>
													</p>
												</div>
												<div className='data'>
													<input
														type='text'
														className='form-control addVehicleSelect'
														autoComplete='off'
														name='make'
														onChange={(e) => {
															onChange(e);
														}}
														style={styles.inputStyles}
													/>
												</div>
												<span
													id='licensePlatesStateSpan'
													className='text-danger danger-msg'
												>
													{makeError && 'Please enter a make!'}
												</span>
											</div>

											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														Type
														<span className='text-danger fw-bold'>
															*
														</span>
													</p>
												</div>
												<div className='data'>
													<Select
														ariaLabel='Default select example'
														placeholder=' '
														style={{
															boxShadow:
																'rgb(116 116 116 / 53%) 0px 0px 1px 1px inset',
														}}
														id='vehicleType'
														name='vehicleType'
														// value={formData?.VehicleType}
														onChange={(e) => onChange(e)}
														list={vehicleTypes}
														className='addVehicleSelect inputBoxShadow'
													/>
												</div>
												<span
													id='licensePlatesStateSpan'
													className='text-danger danger-msg'
												>
													{vehicleTypeError &&
														'Please select vehicle type!'}
												</span>
											</div>

											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														Model{' '}
														<span className='text-danger fw-bold'>
															*
														</span>
													</p>
												</div>
												<div className='data'>
													<input
														type='text'
														className='form-control addVehicleSelect no-arrows'
														autoComplete='off'
														name='model'
														onChange={(e) => {
															onChange(e);
														}}
														onKeyDown={(e) => {
															if (e.key === ' ') {
																e.preventDefault();
															}
														}}
														style={styles.inputStyles}
													/>
												</div>
												<span
													id='licensePlatesStateSpan'
													className='text-danger danger-msg'
												>
													{modelError && 'Please enter a model!'}
												</span>
											</div>

											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														Unit Number{' '}
														<span className='text-danger fw-bold'>
															*
														</span>
													</p>
												</div>
												<div className='data'>
													<input
														type='text'
														className='form-control addVehicleSelect'
														autoComplete='off'
														name='unitNumber'
														value={unitNumber?.unitNumber}
														disabled
														style={styles.inputStyles}
													/>
												</div>
											</div>

											{formData?.vehicleType === 'Unit Guest' && (
												<>
													<div className='card-info-item card-inner'>
														<div className='label'>
															<p className='mx-3 lable_spacing'>
																Arrival Date{' '}
																<span className='text-danger fw-bold'>
																	*
																</span>
															</p>
														</div>
														<div className='data'>
															<DatePicker
																className='form-control addVehicleSelect input_feild'
																clearIcon={null}
																name='MoveInDate'
																onChange={(e) => {
																	setMoveInDateError(false);
																	const formattedDate = e
																		? moment(e).format(
																				'MM/DD/yyyy',
																		  )
																		: '';
																	setFormData({
																		...formData,
																		MoveInDate: formattedDate,
																	});
																}}
																format='MM/dd/yyyy'
																value={
																	formData?.MoveInDate &&
																	formData?.MoveInDate?.length > 0
																		? new Date(
																				formData?.MoveInDate,
																		  )
																		: ''
																}
																minDate={today}
															/>
														</div>

														<span className='text-danger danger-msg'>
															{moveInDateError
																? 'Arrival date required!'
																: ''}
														</span>
													</div>

													<div className='card-info-item card-inner'>
														<p className=' lable_spacing'>
															Arrival Time{' '}
															<span className='text-danger fw-bold'>
																*
															</span>
														</p>
														<input
															class='form-control addVehicleSelect editratelable'
															id='startTime'
															type='time'
															required=''
															placeholder='Enter start time...'
															name='startTime'
															value={formData?.startTime}
															onChange={onChange}
														/>

														<span className='text-danger danger-msg'>
															{startTimeError
																? 'Arrival time required!'
																: ''}
														</span>
													</div>

													<div className='card-info-item card-inner'>
														<div className='label'>
															<p className='mx-3 lable_spacing'>
																End Date{' '}
																<span className='text-danger fw-bold'>
																	*
																</span>
															</p>
														</div>
														<div className='data'>
															<DatePicker
																className='form-control addVehicleSelect input_feild'
																clearIcon={null}
																name='MoveOutDate'
																disabled
																format='MM/dd/yyyy'
																value={
																	formData?.MoveOutDate &&
																	formData?.MoveOutDate?.length >
																		0
																		? new Date(
																				formData?.MoveOutDate,
																		  )
																		: ''
																}
																minDate={
																	formData?.MoveInDate
																		? new Date(
																				formData?.MoveInDate,
																		  )
																		: today
																}
															/>
														</div>{' '}
													</div>

													<div className='card-info-item card-inner'>
														<p className=' lable_spacing'>
															End Time{' '}
															<span className='text-danger fw-bold'>
																*
															</span>
														</p>
														<input
															class='form-control addVehicleSelect editratelable'
															id='endTime'
															type='time'
															disabled
															required=''
															placeholder='Enter start time...'
															name='endTime'
															value={formData?.endTime}
															onChange={onChange}
														/>
													</div>
												</>
											)}
										</div>
									</div>
								</div>
								<Button className='mx-2 mt-3' color='dark' onClick={createVehicle}>
									Save
								</Button>
								<Button
									className='mt-3'
									color='danger'
									onClick={() => navigate('/vehicles?tab=active')}
								>
									Cancel
								</Button>
							</CardBody>
						</Card>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

const styles = {
	dateInput: {
		boxShadow: 'rgb(116 116 116 / 53%) 0px 0px 1px 1px inset',
		lineHeight: '1.5',
		padding: '0.5rem 3rem 0.5rem 1rem',
		height: '3.5rem',
		color: 'transparent',
	},
	onChangeColor: '#323232',
	inputStyles: {
		boxShadow: 'rgb(116 116 116 / 53%) 0px 0px 1px 1px inset',
		lineHeight: '1.5',
		padding: '0.5rem 3rem 0.5rem 1rem',
		height: '3.5rem',
	},
};

export default AddHoldVehicle;
